export default {
  list: {
    headers: {
      id: "ID",
      title: "Title",
      titleBold: "Highlighted title",
      startAt: "Start",
      endAt: "End",
      image: "Image",
    },
  },
  form: {
    labels: {
      title: "Title",
      titleBold: "Highlighted title part",
      description: "Description",
      googleCalendarLink: "Google Calendar link",
      outlookCalendarLink: "Outlook Calendar link",
      calendlyLink: "Calendly link",
      startAt: "Start",
      endAt: "End",
      image: "Image",
      video: "Video",
      currentImageHint: "Select a new file to replace current image.",
      videoUploadAfterSave: "Video upload will be available after saving.",
      videoUploaded: "Video has been uploaded successfully.",
      videoUploadedFile: "File has been uploaded successfully:",
    },
    buttons: {
      add: "Add live session",
      edit: "Save changes",
    },
  },
};
